import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputComponent } from '../../../shared/input/input.component';
import { InputPlusPickerComponent } from '../../../shared/input-plus-picker/input-plus-picker.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RowComponent } from '../../../shared/row/row.component';
import { CheckboxComponent } from '../../../shared/checkbox/checkbox.component';
import { ButtonGroupComponent } from '../../../shared/button-group/button-group.component';
import { InputSelectComponent } from '../../../shared/input-select/input-select.component';

@Component({
  selector: 'app-event-form',
  standalone: true,
  imports: [
    InputComponent,
    InputPlusPickerComponent,
    CommonModule,
    ReactiveFormsModule,
    RowComponent,
    CheckboxComponent,
    ButtonGroupComponent,
    InputSelectComponent,
  ],
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss'],
})
export class EventFormComponent {
  @Input() formGroup!: FormGroup;

  yesNoOptions = [
    { label: $localize`:@@common.yes:Yes`, value: true },
    { label: $localize`:@@common.no:No`, value: false },
  ];
}
